import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';
import type { SharedValue } from 'react-native-reanimated';

import type { RegionTab as RegionTabKey } from '@/features/geo-area/components/region/regionTypes';

export type RegionTabContextValue = {
  activeTab: RegionTabKey;
  scrollY: SharedValue<number>;
  feedInset: number;
  locationBarHeight: number;
  setLocationBarHeight: Dispatch<SetStateAction<number>>;
};

export const RegionTabContext = createContext<
  RegionTabContextValue | undefined
>(undefined);

export const useRegionTab = () => {
  const context = useContext(RegionTabContext);
  if (context === undefined) {
    throw new Error('useRegionTab must be used within RegionTabContext');
  }
  return context;
};
